import React, { useState, useEffect, useCallback } from 'react';
import { newsletterAPI } from '../services/api';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { Mail, Trash2, Users, Calendar } from 'lucide-react';

const AdminNewsletter = () => {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetch = useCallback(async () => { try { setLoading(true); const d = await newsletterAPI.getSubscribers(); setSubscribers(d || []); } catch{ setError('Failed to load subscribers'); } finally { setLoading(false); } }, []);
  useEffect(() => { fetch(); }, [fetch]);

  const handleRemove = async (id) => {
    if (!window.confirm('Remove subscriber?')) return;
    try { await newsletterAPI.removeSubscriber(id); fetch(); } catch(e){ alert('Error removing subscriber'); }
  };

  const activeCount = subscribers.filter(s => s.active).length;

  return (
    <div data-testid="admin-newsletter">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white">Newsletter Subscribers</h1>
        <Badge className="bg-teal-700 text-white text-sm px-4 py-2">
          <Users className="w-4 h-4 mr-2" /> {activeCount} Active
        </Badge>
      </div>

      {loading ? <div className="text-slate-400">Loading...</div> : error ? <div className="text-red-400 text-center py-8">{error}</div> : subscribers.length === 0 ? (
        <div className="text-center text-slate-400 py-12">
          <Mail className="w-16 h-16 mx-auto mb-4 text-slate-600" />
          <p>No subscribers yet. They'll appear here when visitors subscribe.</p>
        </div>
      ) : (
        <div className="space-y-2">{subscribers.map(s=>(
          <Card key={s.id} className="bg-slate-900 border-slate-800" data-testid={`subscriber-${s.id}`}>
            <CardContent className="p-4 flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 bg-teal-700/20 rounded-full flex items-center justify-center"><Mail className="w-5 h-5 text-teal-400" /></div>
                <div>
                  <p className="text-white font-medium">{s.email}</p>
                  <div className="flex items-center gap-3 text-slate-500 text-xs mt-0.5">
                    {s.name && <span>{s.name}</span>}
                    {s.subscribed_at && <span className="flex items-center gap-1"><Calendar className="w-3 h-3" />{new Date(s.subscribed_at).toLocaleDateString()}</span>}
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                {s.active ? <Badge className="bg-green-500/10 text-green-400 text-xs">Active</Badge> : <Badge className="bg-red-500/10 text-red-400 text-xs">Inactive</Badge>}
                <Button size="sm" variant="ghost" onClick={()=>handleRemove(s.id)} className="text-slate-400 hover:text-red-400"><Trash2 className="w-4 h-4" /></Button>
              </div>
            </CardContent>
          </Card>
        ))}</div>
      )}
    </div>
  );
};
export default AdminNewsletter;
